export default __webpack_public_path__ + "static/media/Block.6f09cd2d.svg";